import { remove, get, post, put } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async get() {
    return await get("user");
  },

  async resetAuthCookie() {
    await post("user/resetAuthCookie");
  },

  async getUsersByCustomerId(customerId) {
    return await get(
      uriWithQueryStringParams("userMaintenance/registeredUsers", {
        customerId
      })
    );
  },

  async getPendingUsersByCustomerId(customerId) {
    return await get(
      uriWithQueryStringParams("userMaintenance/pendingUsers", { customerId })
    );
  },

  async validateEmailAddress(email, customerId) {
    try {
      const user = await get(
        uriWithQueryStringParams("userMaintenance/FindUser", {
          email,
          customerId
        })
      );
      return {
        exists: true,
        user
      };
    } catch (statusCode) {
      if (statusCode === 404) {
        return { exists: false };
      } else if (statusCode === 409) {
        return { exists: true };
      }
    }
  },

  async getExistingUser(username, customerId) {
    return await get(
      uriWithQueryStringParams("userMaintenance", { username, customerId })
    );
  },

  async saveUser(user) {
    if (user.userName) {
      return await put("userMaintenance", user);
    } else {
      return await post("userMaintenance", user);
    }
  },

  async getUserReportSubscriptions(username) {
    return await get(
      uriWithQueryStringParams("userMaintenance/getReportSubscriptions", {
        username
      })
    );
  },

  async setUserActiveStatus(username, status, force) {
    await put(
      uriWithQueryStringParams("userMaintenance/setActiveStatus", {
        username,
        isActive: status,
        force
      })
    );
  },

  async setCustomerDefaultNewUsersToSsoOnly(customerId, flag, force) {
    await put(
      uriWithQueryStringParams("userMaintenance/setDefaultNewUsersToSsoOnly", {
        customerId,
        defaultNewUsersToSsoOnly: flag,
        force
      })
    );
  },

  async setUserEnableBasicAuthFlag(username, flag, force) {
    await put(
      uriWithQueryStringParams("userMaintenance/setEnableBasicAuth", {
        username,
        enableBasicAuth: flag,
        force
      })
    );
  },

  async setUserEnableSsoAuthFlag(username, flag, force) {
    await put(
      uriWithQueryStringParams("userMaintenance/setEnableSsoAuth", {
        username,
        enableSsoAuth: flag,
        force
      })
    );
  },

  async resetAccountLockout(username, customerId) {
    return await put(
      uriWithQueryStringParams("userMaintenance/Reset", {
        username,
        customerId
      })
    );
  },

  async resendEmail(customerId, userName) {
    await put("userMaintenance/resend", { customerId, userName });
  },

  async revokePendingUser(user) {
    await remove("userMaintenance", user);
  }
};
